module.exports = __webpack_public_path__ + "static/media/Sajek.2126899a.png";